module.exports = __webpack_public_path__ + "static/media/Noto5.d226270b.webp";